<template>
  <div v-if="user" class="margin-5">
    <p class="subtitle is-6 has-text-weight-medium lineheight-medium is-marginless">
      <span>Hey {{user.firstName || user.phoneNumber}}!</span>
      <button
        class="button is-outlined is-small is-pulled-right"
        :class="[isLoading ? 'is-loading' : '', hideLogOut ? 'is-hidden': '']"
        @click="signOut"
      >
        <span class="icon">
          <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
        </span>
      </button>
    </p>
    <p v-if="!hideCustInfo && customerLoyalty && (customerLoyalty.loyaltyPoints > 0 || customerLoyalty.loyaltyValue > 0)" class="subtitle is-7 lineheight-medium">
      <span>You have </span>
      <span class="has-text-weight-semibold" v-if="customerLoyalty.loyaltyPoints">{{ customerLoyalty.loyaltyPoints }}</span>
      <span> loyalty points </span>
      <span v-if="customerLoyalty.loyaltyValue"> of value <span class="has-text-weight-semibold" v-html="formatPrice(customerLoyalty.loyaltyValue)"></span></span>.
    </p>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Util from '@/util';

export default {
  name: "UserToolbar",
  props: ['hideLogOut', 'hideCustInfo'],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapState("user", ["user"]),
    ...mapState("cart", ["customerLoyalty"])
  },

  methods: {
    signOut() {
      this.isLoading = true;
      this.$store
        .dispatch("user/signOut")
        .then(() => {
          this.isLoading = false;
        })
        .catch(error => {
          Util.notify(this, { error });
          this.isLoading = false;
        });
    },
    formatPrice(price) {
      return Util.formatPrice(price)
    }
  }
};
</script>
